import { render } from "./agreeItem_02.vue?vue&type=template&id=444cfdf4&scoped=true&ts=true"
import script from "./agreeItem_02.vue?vue&type=script&lang=ts"
export * from "./agreeItem_02.vue?vue&type=script&lang=ts"

import "./agreeItem_02.vue?vue&type=style&index=0&id=444cfdf4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444cfdf4"]])

export default __exports__